import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Sidebar from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar';
import Content from './Content';

const styles = () => ({
  root: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    flexShrink: 0,
  },
  content: {
    height: '100%',
  },
});

const LeftSide = ({
  classes,
}) => {
  return (
    <div className={classes.root}>
      <Sidebar className={classes.sidebar} />
      <Content className={classes.content} />
    </div>
  );
};

LeftSide.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeftSide);
